import { toast } from "sonner";

/**
 * Display an etag-mismatch error toast with a reload action.
 * Used when a 409 conflict is detected (recipe changed elsewhere).
 */
export function handleEtagMismatch() {
  toast.error("Recipe changed elsewhere — reload to get the latest", {
    duration: 10000,
    action: {
      label: "Reload",
      onClick: () => {
        window.location.reload();
      },
    },
  });
}
